import { HINDU_D, HINDU_DECK, HINDU_GAP_MS, HINDU_MAX_LIFTS, HINDU_MOVE_MS } from "./hinduGeom.js";
import { packetPose, restSeat, stillInside } from "./hinduPose.js";

export { HINDU_MOVE_MS, HINDU_TOTAL_MS } from "./hinduGeom.js";

export type HinduStep = {
  lift: number;
  rest: number;
  packet: number;
  t: number;
  hiding: boolean;
  restLift: number;
  done: boolean;
};

export function packetSize(step: number) {
  return [3, 2, 4, 1, 3, 2][step % 6];
}

function moveStep(lift: number, t: number): HinduStep {
  const packet = packetSize(lift);
  return {
    lift,
    rest: HINDU_DECK - packet,
    packet,
    t,
    hiding: stillInside(t),
    restLift: packet * HINDU_D * (1 - restSeat(t)),
    done: false,
  };
}

function idleStep(lift: number, done: boolean): HinduStep {
  return {
    lift,
    rest: HINDU_DECK,
    packet: 0,
    t: 1,
    hiding: false,
    restLift: 0,
    done,
  };
}

export function hinduStepAt(elapsed: number): HinduStep {
  let t = Math.max(0, elapsed);
  for (let lift = 0; lift < HINDU_MAX_LIFTS; lift += 1) {
    if (t < HINDU_MOVE_MS) return moveStep(lift, t / HINDU_MOVE_MS);
    t -= HINDU_MOVE_MS;
    if (lift === HINDU_MAX_LIFTS - 1) return idleStep(HINDU_MAX_LIFTS, true);
    if (t < HINDU_GAP_MS) return idleStep(lift, false);
    t -= HINDU_GAP_MS;
  }
  return idleStep(HINDU_MAX_LIFTS, true);
}

export function hinduPacketPose(step: HinduStep) {
  return packetPose(step.t, step.rest);
}
